import React from "react";

export default function PageIntro({ eyebrow, title, intro, note, titleId }) {
  return (
    <section className="content-wrapper qa-page-intro" aria-labelledby={titleId}>
      <header className="content-header qa-page-hero">
        <div className="qa-page-hero-primary">
          {eyebrow && <p className="bodycopy qa-case-eyebrow">{eyebrow}</p>}
          <span className="qa-landing-rule" aria-hidden="true" />
          <h1 id={titleId} className="h1">{title}</h1>
        </div>
        {(intro || note) && <div className="qa-page-hero-support">
          {intro && <p className="bodycopy qa-lead">{intro}</p>}
          {note && <p className="bodycopy qa-page-hero-note">{note}</p>}
        </div>}
      </header>
    </section>
  );
}
